module.exports = __webpack_public_path__ + "img/epos2.89a4df18.jpg";